import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "melavi_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, size, opts = {}) => {
    const isPair = !!opts.isPair;
    const key = `${product.slug}::${size}::${isPair ? "pair" : "solo"}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i));
      }
      const unit = isPair && product.pair_price ? product.pair_price : product.price;
      return [
        ...prev,
        {
          key, slug: product.slug, name: product.name, size, qty: 1, is_pair: isPair,
          unit_price: unit, image: (product.images || [{}])[0].url,
        },
      ];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const setQty = (key, qty) => setItems((p) => p.map((i) => (i.key === key ? { ...i, qty: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.unit_price * i.qty, 0);
  const shipping = subtotal === 0 ? 0 : (subtotal >= 1499 ? 0 : 79);
  const total = subtotal + shipping;
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, shipping, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart used outside CartProvider");
  return ctx;
};
